import { render, staticRenderFns } from "./Changelog.vue?vue&type=template&id=77605e7e&scoped=true"
import script from "./Changelog.vue?vue&type=script&lang=js"
export * from "./Changelog.vue?vue&type=script&lang=js"
import style0 from "./Changelog.vue?vue&type=style&index=0&id=77605e7e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77605e7e",
  null
  
)

export default component.exports